var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer mt-auto py-3"},[_c('div',{staticClass:"text-center container"},[_c('span',{staticClass:"text-muted"},[_vm._v("Galenit "+_vm._s(_vm.year)+" - "+_vm._s(_vm.$store.getters.appVersion))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }